export default "__VITE_ASSET__DvBRkHnE__"